import {
  CountryCode,
  CurrencyCode,
  DISPLAY_PLACEHOLDER,
  LocaleCode,
  StorageKey,
} from "constants/enums";
import { DEFAULT_ISD_CODE } from "constants/phoneConfig";

export { DISPLAY_PLACEHOLDER };

export const getLocaleForCountryCode = (countryCode) =>
  countryCode === CountryCode.IND ? LocaleCode.EN_IN : LocaleCode.EN_US;

export const getLocaleForCurrencyCode = (currencyCode) =>
  currencyCode === CurrencyCode.INR ? LocaleCode.EN_IN : LocaleCode.EN_US;

export const normalizeCountryMappings = (items = []) =>
  items
    .map((item) => {
      const details = item?.details || {};
      const isd = details.isd_codes?.[0];
      const currency = details.currencies?.[0];

      if (!details.code || !isd?.code || !currency?.code) {
        return null;
      }

      return {
        countryId: item.id,
        countryCode: details.code,
        countryName: details.display_name || details.name,
        isdCode: isd.code,
        currencyCode: currency.code,
        locale: getLocaleForCountryCode(details.code),
      };
    })
    .filter(Boolean);

export const getDefaultCountry = (
  countries = [],
  preferredIsd = DEFAULT_ISD_CODE
) => {
  if (!countries.length) {
    return null;
  }

  const byIsd = countries.find((country) => country.isdCode === preferredIsd);
  if (byIsd) {
    return byIsd;
  }

  const india = countries.find(
    (country) => country.countryCode === CountryCode.IND
  );
  return india || countries[0];
};

export const getStoredCountry = () => {
  try {
    const raw = localStorage.getItem(StorageKey.SELECTED_COUNTRY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const persistSelectedCountry = (country) => {
  if (!country) {
    localStorage.removeItem(StorageKey.SELECTED_COUNTRY);
    return;
  }
  localStorage.setItem(StorageKey.SELECTED_COUNTRY, JSON.stringify(country));
};

export const resolveSelectedCountry = (countries = []) => {
  const stored = getStoredCountry();
  if (stored?.countryCode) {
    const match = countries.find(
      (country) => country.countryCode === stored.countryCode
    );
    if (match) {
      return match;
    }
  }
  return getDefaultCountry(countries);
};

export const toCountrySelectOptions = (countries = []) =>
  countries.map((country) => ({
    id: country.countryId,
    value: country.countryCode,
    label: `${country.countryName} (${country.isdCode})`,
  }));

/** Compact phone-field options: show ISD only (e.g. +91). */
export const toIsdSelectOptions = (countries = []) =>
  countries.map((country) => ({
    id: country.countryId,
    value: country.countryCode,
    label: country.isdCode,
  }));

export const getOrderCurrencyCode = (order) => order?.currency?.name;

export const getOrderPendingAmount = (order) => {
  if (!order) {
    return 0;
  }

  if (order.pending_amount != null) {
    return Number(order.pending_amount) || 0;
  }

  if (order.amount_paid != null) {
    return (Number(order.amount) || 0) - (Number(order.amount_paid) || 0);
  }

  return (
    (Number(order.inr_conversion_amount) || 0) -
    (Number(order.inr_conversion_amount_paid) || 0)
  );
};
